import { BreachPathGraphNodeTypeWebComponent } from './component/BreachPathGraphNodeTypeWebComponent';

export { BreachPathGraphNodeTypeWebComponent };
